module.exports = __webpack_public_path__ + "static/img/Rambaudi.b62dc866.jpg";